import type { AnyAction } from '@reduxjs/toolkit';

/**
 * Modal type constants for the global modal system.
 * These constants are used throughout the app to open modals.
 */
export const MODAL_TYPES = {
  // Onboarding modals
  PATIENT_COMMUNICATION_ONBOARDING: 'PATIENT_COMMUNICATION_ONBOARDING',

  // Feature modals
  NEW_FEATURE: 'NEW_FEATURE',
  VERSION_UPDATE: 'VERSION_UPDATE',
  ENABLE_EHR_MODE: 'ENABLE_EHR_MODE',

  // Patient modals
  NEW_PATIENT: 'NEW_PATIENT',
  PATIENT_INFO_COLLECTION: 'PATIENT_INFO_COLLECTION',

  // Payment modals
  STRIPE_CONNECT_INFO: 'STRIPE_CONNECT_INFO',
  PAYMENT_REQUEST: 'PAYMENT_REQUEST',

  // Toolbar action modals
  SEND_COMMUNICATION: 'SEND_COMMUNICATION',
  LAB_ORDER: 'LAB_ORDER',
  GENERATE_DOCUMENT: 'GENERATE_DOCUMENT',
  REQUEST_PAYMENT: 'REQUEST_PAYMENT',

  // Document viewer modals
  PDF_VIEWER: 'PDF_VIEWER',

  FIX_SPELLING: 'FIX_SPELLING',
  JOTDOC_FIND_REPLACE: 'JOTDOC_FIND_REPLACE',
  // Settings modals
  COPY_PASTE_PREFERENCES: 'COPY_PASTE_PREFERENCES',

  // Consent modals
  CONSENT_INFORMATION: 'CONSENT_INFORMATION',

  // Appointment selection modal
  APPOINTMENT_SELECTION: 'APPOINTMENT_SELECTION',

  // Appointment types management modal
  APPOINTMENT_TYPES_MANAGEMENT: 'APPOINTMENT_TYPES_MANAGEMENT',

  // JotCoach feedback modal
  JOTCOACH_FEEDBACK: 'JOTCOACH_FEEDBACK',

  // Approval modal
  APPROVAL_MODAL: 'APPROVAL_MODAL',

  // Add new modal types here...
} as const;

/**
 * TypeScript type derived from the modal types object.
 * This ensures type safety when using modal types.
 */
export type ModalType = (typeof MODAL_TYPES)[keyof typeof MODAL_TYPES];

/**
 * Continuation action interface for post-modal callbacks.
 * Allows modals to dispatch Redux actions after completion.
 */
export interface ContinuationAction extends AnyAction {
  type: string;
  payload?: any;
  meta?: any;
}

/**
 * Standard props interface for all modal components.
 * All modals in the system should accept these props.
 */
export interface ModalComponentProps {
  modalProps: Record<string, any> & {
    continuationAction?: ContinuationAction;
  };
  closeModal: () => void;
}
